import { Modal, Button } from 'react-bootstrap';
import FailedLogin from "../../images/failed-login.png";
import RoundCloseButton from "../../images/round-close-button.png";

interface ModalFailedLoginProps {
  show: boolean;
  onHide: () => void;
  resetPassword: () => void;
};

function ModalFailedLogin({
  show,
  onHide,
  resetPassword
}: ModalFailedLoginProps) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      id={"failed-login"}
      centered
    >
      <Modal.Body>
        <KickImage onClick={onHide} className='close-icon' src={RoundCloseButton} alt="..." />
        <KickImage src={FailedLogin} alt="..." />
        <p className="title">Hold On</p>
        <p className="text">You have attempted too many time, <span style={{ display: "block" }}>
          please reset your password to login to your account.
        </span>
        </p>
        <Button onClick={() => resetPassword()}>Reset Password</Button>
      </Modal.Body>
    </Modal>
  );
}

export default ModalFailedLogin;
